<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.komfirmasi"
          @keydown.esc="dialog.komfirmasi = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Konfirmasi Ubah Saldo Awal

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.komfirmasi = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Aksi ini akan mereset semua jurnal yg telah dibuat sebelumnya
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="saldo_awal_bool = false; dialog.komfirmasi = false; dialog.fullscreen = false;"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Lanjutkan
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.komfirmasi = false; dialog.fullscreen = false;"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="800"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Set Saldo Awal
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Pilih Bulan
                  </div>

                  <v-menu
                    ref="range"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="picker.month">
                    <template v-slot:activator="{ on, attrs }">
                      <!-- <v-text-field
                        readonly
                        filled
                        rounded
                        dense
                        single-line
                        :color="set_color"
                        placeholder="Contoh. 2023-01-01 s/d 2023-12-01"

                        hide-details

                        v-on="on"
                        v-bind="attrs"

                        v-model="date_range"
                        class="mb-2"
                        style="border-radius: 10px !important;">
                      </v-text-field> -->

                      <v-card
                        v-on="on"
                        v-bind="attrs"

                        flat
                        color="#f2f2f2"
                        class="mb-2"
                        style="border-radius: 10px;">
                        <div
                          class="d-flex align-center"
                          style="padding: 9px;">
                          <!-- <v-icon>mdi-calendar-multiselect-outline</v-icon> -->

                          <div
                            class="body-1 ml-1">
                            <!-- {{ filter.dates[0] | date_month }} - {{ filter.dates[1] | fulldate }} -->
                            {{ form.month | month_year }}
                          </div>
                        </div>
                      </v-card>
                    </template>
                    
                    <v-date-picker 
                      type="month"
                      :color="set_color"
                      v-model="form.month"
                      @input="picker.month = form.month.length > 1 ? false : true">
                    </v-date-picker>
                  </v-menu>

                  <div class="d-flex align-center mt-3" style="border-bottom: 1px solid #eee;">
                    <div style="width: 156px; min-width: 156px;" class="font_weight_600 black_one py-2">
                      No. Akun
                    </div>
                    <div class="py-2 font_weight_600 black_one">
                      Nama Akun
                    </div>
                    <div class="ml-auto py-2 font_weight_600 black_one">
                      Saldo
                    </div>
                  </div>

                  <div class="fs-14 pb-2 pt-2 black_one font_weight_600" style="border-bottom: 1px solid #eee;">
                    Aktiva
                  </div>
                  <div v-for="(item, index) in form.aktiva_array" :key="index">
                    <div class="d-flex align-center fs-12" style="border-bottom: 1px solid #eee;">
                      <div style="width: 156px; min-width: 156px;" class="py-2">
                        {{ item.number }}
                      </div>
                      <div class="py-2">
                        {{ item.name }}
                      </div>
                      <div class="ml-auto py-2" v-if="item.child.length < 1">
                        <v-currency-field
                          rounded
                          :readonly="saldo_awal_bool"
                          dense
                          outlined
                          hide-details
    
                          :color="set_color"
                          placeholder="Saldo"
                          :error-messages="errors"

                          
                          class="min-height-input fs-14"
                          v-model="item.saldo"
                          style="border-radius: 10px; width: 200px; max-width: 200px;">
                        </v-currency-field>
                      </div>
                    </div>
                    <div v-if="item.child.length > 0">
                      <div v-for="(c1, i1) in item.child" :key="i1">
                        <div class="d-flex pl-3 align-center fs-12" style="border-bottom: 1px solid #eee;">
                          <div style="width: 144px; min-width: 144px;" class="py-2">
                            {{ c1.number }}
                          </div>
                          <div class="py-2">
                            {{ c1.name }}
                          </div>
                          <div class="ml-auto py-2" v-if="c1.child.length < 1">
                            <v-currency-field
                              rounded
                              :readonly="saldo_awal_bool"
                              dense
                              outlined
                              hide-details
        
                              :color="set_color"
                              placeholder="Saldo"
                              :error-messages="errors"

                              
                              class="min-height-input fs-14"
                              v-model="c1.saldo"
                              style="border-radius: 10px; width: 200px; max-width: 200px;">
                            </v-currency-field>
                          </div>
                        </div>
                        <div v-if="c1.child.length > 0">
                          <div v-for="(c2, i2) in c1.child" :key="i2">
                            <div class="d-flex pl-6 align-center fs-12" style="border-bottom: 1px solid #eee;">
                              <div style="width: 132px; min-width: 132px;" class="py-2">
                                {{ c2.number }}
                              </div>
                              <div class="py-2">
                                {{ c2.name }}
                              </div>
                              <div class="ml-auto py-2" v-if="c2.child.length < 1">
                                <v-currency-field
                                  rounded
                                  :readonly="saldo_awal_bool"
                                  dense
                                  outlined
                                  hide-details
            
                                  :color="set_color"
                                  placeholder="Saldo"
                                  :error-messages="errors"
  
                                  
                                  class="min-height-input fs-14"
                                  v-model="c2.saldo"
                                  style="border-radius: 10px; width: 200px; max-width: 200px;">
                                </v-currency-field>
                              </div>
                            </div>
                            <div v-if="c2.child.length > 0">
                              <div v-for="(c3, i3) in c2.child" :key="i3">
                                <div class="d-flex pl-9 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                  <div style="width: 120px; min-width: 120px;" class="py-2">
                                    {{ c3.number }}
                                  </div>
                                  <div class="py-2">
                                    {{ c3.name }}
                                  </div>
                                  <div class="ml-auto py-2" v-if="c3.child.length < 1">
                                    <v-currency-field
                                      rounded
                                      :readonly="saldo_awal_bool"
                                      dense
                                      outlined
                                      hide-details
                
                                      :color="set_color"
                                      placeholder="Saldo"
    
                                      
                                      class="min-height-input fs-14"
                                      v-model="c3.saldo"
                                      style="border-radius: 10px; width: 200px; max-width: 200px;">
                                    </v-currency-field>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="fs-14 pb-2 pt-2 black_one font_weight_600" style="border-bottom: 1px solid #eee;">
                    Pasiva
                  </div>
                  
                  <div v-for="(item, index) in form.pasiva_array" :key="index">
                    <div class="d-flex align-center fs-12" style="border-bottom: 1px solid #eee;">
                      <div style="width: 156px; min-width: 156px;" class="py-2">
                        {{ item.number }}
                      </div>
                      <div class="py-2">
                        {{ item.name }}
                      </div>
                      <div class="ml-auto py-2" v-if="item.child.length < 1">
                        <v-currency-field
                          rounded
                          :readonly="saldo_awal_bool"
                          dense
                          outlined
                          hide-details
    
                          :color="set_color"
                          placeholder="Saldo"
                          :error-messages="errors"

                          
                          class="min-height-input fs-14"
                          v-model="item.saldo"
                          style="border-radius: 10px; width: 200px; max-width: 200px;">
                        </v-currency-field>
                      </div>
                    </div>
                    <div v-if="item.child.length > 0">
                      <div v-for="(c1, i1) in item.child" :key="i1">
                        <div class="d-flex pl-3 align-center fs-12" style="border-bottom: 1px solid #eee;">
                          <div style="width: 144px; min-width: 144px;" class="py-2">
                            {{ c1.number }}
                          </div>
                          <div class="py-2">
                            {{ c1.name }}
                          </div>
                          <div class="ml-auto py-2" v-if="c1.child.length < 1">
                            <v-currency-field
                              rounded
                              :readonly="saldo_awal_bool"
                              dense
                              outlined
                              hide-details
        
                              :color="set_color"
                              placeholder="Saldo"
                              :error-messages="errors"

                              
                              class="min-height-input fs-14"
                              v-model="c1.saldo"
                              style="border-radius: 10px; width: 200px; max-width: 200px;">
                            </v-currency-field>
                          </div>
                        </div>
                        <div v-if="c1.child.length > 0">
                          <div v-for="(c2, i2) in c1.child" :key="i2">
                            <div class="d-flex pl-6 align-center fs-12" style="border-bottom: 1px solid #eee;">
                              <div style="width: 132px; min-width: 132px;" class="py-2">
                                {{ c2.number }}
                              </div>
                              <div class="py-2">
                                {{ c2.name }}
                              </div>
                              <div class="ml-auto py-2" v-if="c2.child.length < 1">
                                <v-currency-field
                                  rounded
                                  :readonly="saldo_awal_bool"
                                  dense
                                  outlined
                                  hide-details
            
                                  :color="set_color"
                                  placeholder="Saldo"
                                  :error-messages="errors"
  
                                  
                                  class="min-height-input fs-14"
                                  v-model="c2.saldo"
                                  style="border-radius: 10px; width: 200px; max-width: 200px;">
                                </v-currency-field>
                              </div>
                            </div>
                            <div v-if="c2.child.length > 0">
                              <div v-for="(c3, i3) in c2.child" :key="i3">
                                <div class="d-flex pl-9 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                  <div style="width: 120px; min-width: 120px;" class="py-2">
                                    {{ c3.number }}
                                  </div>
                                  <div class="py-2">
                                    {{ c3.name }}
                                  </div>
                                  <div class="ml-auto py-2" v-if="c3.child.length < 1">
                                    <v-currency-field
                                      rounded
                                      :readonly="saldo_awal_bool"
                                      dense
                                      outlined
                                      hide-details
                
                                      :color="set_color"
                                      placeholder="Saldo"
    
                                      
                                      class="min-height-input fs-14"
                                      v-model="c3.saldo"
                                      style="border-radius: 10px; width: 200px; max-width: 200px;">
                                    </v-currency-field>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
            class="pa-4">
            <div v-if="message.error.length > 0"
              class="text-left">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->

          <v-card
            flat
            class="mt-2"
            color="transparent">
            <div
              class="d-flex align-center px-3">
              <div
                class="d-flex align-center">
                <v-avatar
                  tile
                  size="22">
                  <v-img
                    contain
                    alt="kominfoklaten"  
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Set Saldo Awal
                </span>
              </div>

              <v-spacer />

            </div>
          </v-card>
          
          <div class="d-flex mt-5 px-4">
            <!-- <div>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="filter.date"
                transition="scale-transition"
                offset-y
                min-width="auto"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filter.date"
                    :color="set_color"
                    placeholder="Pilihan periode"
                    prepend-inner-icon="mdi-calendar"
                    hide-details
                    readonly
                    filled
                    rounded
                    clearable
                    dense
                    v-bind="attrs"
                    v-on="on"
                    style="border-radius: 10px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.date"
                  no-title
                  scrollable
                  type="month"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(filter.date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div> -->
            <!-- <div>
              <v-select
                filled
                rounded
                dense
                hide-details

                :color="set_color"
                placeholder="Contoh. 2023"

                :items="years"
                :item-color="set_color"

                v-model="filter.year"
                style="border-radius: 10px; width: 200px; max-width: 200px;">
              </v-select>
            </div>

            <div>
              <v-select
                filled
                rounded
                dense

                :color="set_color"
                placeholder="Contoh. Januari"

                :items="months"
                item-text="text"
                item-value="value"
                :item-color="set_color"
                hide-details
                class="mx-4"

                v-model="filter.month"
                style="border-radius: 10px; width: 200px; max-width: 200px;">
              </v-select>
            </div> -->
            <v-btn
              color="#4B4B4B"
              elevation="0"
              :disabled="process.load"
              small
              min-height="20"
              v-if="saldo_awal_bool"
              @click="dialog.komfirmasi = true;"
              class="fs-12 white--text text-capitalize d-flex align-center ml-0"
              style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
              <v-icon size="18">mdi-plus-circle-multiple</v-icon>
              
              <span
                class="ml-2">
                Ubah Saldo
              </span>
            </v-btn>
            <!-- <div>
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field>
            </div> -->
            <!-- <div class="ml-3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :loading="process.export"
                    elevation="0"
                    outlined
                    dark
                    min-width="36"
                    color="#7B7B7B"
                    class="text-capitalize px-0"
                    style="border-radius: 10px;"
                    v-bind="attrs"
                    v-on="on">
                    <v-icon size="18">mdi-tray-full</v-icon>
                  </v-btn>
                </template>

                <span>
                  Export
                </span>
              </v-tooltip>
            </div> -->
            <!-- <v-btn
              color="#4B4B4B"
              elevation="0"
              class="body-2 white--text text-capitalize d-flex align-center ml-4"
              style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
              <v-icon size="20">mdi-plus-circle-multiple</v-icon>
              
              <span
                class="ml-2">
                Tambah
              </span>
            </v-btn> -->
          </div>
          <v-row
            class="pa-4 py-0 mt-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 256px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>

                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>

                  <div v-if="!process.load">
                    <v-card-text 
                      class="py-0 my-4">
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Pilih Bulan
                          </div>
                          <div class="d-flex align-center">
                            <div>
    
                              <v-menu
                                ref="range"
                                min-width="290px"
                                max-width="290px"
                                transition="scale-transition"
                                offset-y
                                :nudge-right="40"
                                :close-on-content-click="false"
                                v-model="picker.month">
                                <template v-slot:activator="{ on, attrs }">
                                  <!-- <v-text-field
                                    readonly
                                    filled
                                    rounded
                                    dense
                                    single-line
                                    :color="set_color"
                                    placeholder="Contoh. 2023-01-01 s/d 2023-12-01"
    
                                    hide-details
    
                                    v-on="on"
                                    v-bind="attrs"
    
                                    v-model="date_range"
                                    class="mb-2"
                                    style="border-radius: 10px !important;">
                                  </v-text-field> -->
    
                                  <v-card
                                    v-on="saldo_awal_bool ? '' : on"
                                    v-bind="saldo_awal_bool ? '' : attrs"
    
                                    flat
                                    color="#f2f2f2"
                                    class="mb-0"
                                    style="border-radius: 10px; width: 130px; min-width: 130px; max-width: 130px;">
                                    <div
                                      class="d-flex align-center"
                                      style="padding: 9px;">
                                      <!-- <v-icon>mdi-calendar-multiselect-outline</v-icon> -->
    
                                      <div
                                        class="fs-13 ml-1">
                                        <!-- {{ filter.dates[0] | date_month }} - {{ filter.dates[1] | fulldate }} -->
                                        {{ form.month | month_year }}
                                      </div>
                                    </div>
                                  </v-card>
                                </template>
                                
                                <v-date-picker 
                                  type="month"
                                  :color="set_color"
                                  v-model="form.month"
                                  @input="picker.month = form.month.length > 1 ? false : true">
                                </v-date-picker>
                              </v-menu>
                            </div>
                            <div class="ml-auto d-flex">
                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one fs-12 font_weight_600">
                                    Total Aktiva: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="(total_aktiva !== total_pasiva) ? 'red--text' : 'black_one'">
                                    {{ total_aktiva | price }}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one font_weight_600 fs-12">
                                    Total Pasiva: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="(total_aktiva !== total_pasiva) ? 'red--text' : 'black_one'">
                                    {{ total_pasiva | price }}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one font_weight_600 fs-12">
                                    Total Pendapatan: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="'black_one'">
                                    {{ total_pendapatan | price }}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one font_weight_600 fs-12">
                                    Total Biaya: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="'black_one'">
                                    {{ total_biaya | price }}
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one fs-12 font_weight_600">
                                    Total Aktiva Public: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="(total_aktiva_public !== total_pasiva_public) ? 'red--text' : 'black_one'">
                                    {{ total_aktiva_public | price }}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one font_weight_600 fs-12">
                                    Total Pasiva Public: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="(total_aktiva_public !== total_pasiva_public) ? 'red--text' : 'black_one'">
                                    {{ total_pasiva_public | price }}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one font_weight_600 fs-12">
                                    Total Pendapatan Public: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="'black_one'">
                                    {{ total_pendapatan_public | price }}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div style="" class="text-right px-4">
                                  <div class="black_one font_weight_600 fs-12">
                                    Total Biaya Public: 
                                  </div>
                                  <div class="font_weight_600 fs-13 ml-2" :class="'black_one'">
                                    {{ total_biaya_public | price }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <v-divider class="mt-2"></v-divider>

                          <div class="d-flex align-center mt-0 pl-2" style="border-bottom: 1px solid #eee;" :style="`background-color: ${set_color};`">
                            <div style="width: 156px; min-width: 156px;" class="font_weight_600 white--text py-2">
                              No. Akun
                            </div>
                            <div class="py-2 font_weight_600 white--text" style="width: 100%;">
                              Nama Akun
                            </div>
                            <div class="py-2 font_weight_600 white--text pr-4 text-right" style="width: 300px; max-width: 300px; min-width: 300px;">
                              Saldo Internal
                            </div>
                            <div class="ml-auto py-2 font_weight_600 white--text pr-4 text-right" style="width: 300px; max-width: 300px; min-width: 300px;">
                              Saldo Public
                            </div>
                          </div>
                          <div class="pl-2" style="height: calc(100vh - 380px); overflow-y: auto; padding-right: 8px;">

                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600" style="border-bottom: 1px solid #eee;">
                              Aktiva
                            </div>
                            <div v-for="(item, index) in form.aktiva_array" :key="index">
                              <div class="d-flex align-center fs-12" style="border-bottom: 1px solid #eee;">
                                <div style="width: 156px; min-width: 156px;" class="py-1">
                                  {{ item.number }}
                                </div>
                                <div class="py-1" style="width: 100%;">
                                  {{ item.name }}
                                </div>
                                <div class="ml-auto py-1" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool"
                                    @input="akumulasiAktiva()"
                                    dense
                                    outlined
                                    hide-details
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                                <div class="ml-auto py-1" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool"
                                    @input="akumulasiAktivaPublic()"
                                    dense
                                    outlined
                                    hide-details
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo_public"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                              </div>
                              <div v-if="item.child.length > 0">
                                <div v-for="(c1, i1) in item.child" :key="i1">
                                  <div class="d-flex pl-3 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                    <div style="width: 144px; min-width: 144px;" class="py-1">
                                      {{ c1.number }}
                                    </div>
                                    <div class="py-1" style="width: 100%;">
                                      {{ c1.name }}
                                    </div>
                                    <div class="py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool"
                                        @input="akumulasiAktiva()"
                                        dense
                                        outlined
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                    <div class="ml-auto py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool"
                                        @input="akumulasiAktivaPublic()"
                                        dense
                                        outlined
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo_public"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                  </div>
                                  <div v-if="c1.child.length > 0">
                                    <div v-for="(c2, i2) in c1.child" :key="i2">
                                      <div class="d-flex pl-6 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                        <div style="width: 132px; min-width: 132px;" class="py-1">
                                          {{ c2.number }}
                                        </div>
                                        <div class="py-1" style="width: 100%;">
                                          {{ c2.name }}
                                        </div>
                                        <div class="py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool"
                                            @input="akumulasiAktiva()"
                                            dense
                                            outlined
                                            hide-details
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                        <div class="ml-auto py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool"
                                            @input="akumulasiAktivaPublic()"
                                            dense
                                            outlined
                                            hide-details
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo_public"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                      </div>
                                      <div v-if="c2.child.length > 0">
                                        <div v-for="(c3, i3) in c2.child" :key="i3">
                                          <div class="d-flex pl-9 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                            <div style="width: 120px; min-width: 120px;" class="py-1">
                                              {{ c3.number }}
                                            </div>
                                            <div class="py-1" style="width: 100%;">
                                              {{ c3.name }}
                                            </div>
                                            <div class="py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool"
                                                @input="akumulasiAktiva()"
                                                dense
                                                outlined
                                                hide-details
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                            <div class="ml-auto py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool"
                                                @input="akumulasiAktivaPublic()"
                                                dense
                                                outlined
                                                hide-details
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo_public"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600" style="border-bottom: 1px solid #eee;">
                              Pasiva
                            </div>
                            
                            <div v-for="(item, index) in form.pasiva_array" :key="index">
                              <div class="d-flex align-center fs-12" style="border-bottom: 1px solid #eee;">
                                <div style="width: 156px; min-width: 156px;" class="py-1" :class="item.laba_bool ? 'pink--text text--darken-1' : item.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                  {{ item.number }}
                                </div>
                                <div class="py-1" style="width: 100%;" :class="item.laba_bool ? 'pink--text text--darken-1' : item.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                  {{ item.name }} <span v-if="item.laba_bool">(Saldo akhir<span>{{ (new Date(new Date(form.month).getFullYear(), (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span> <span v-if="item.laba_tahun_bool">(saldo akhir Januari<span v-if="new Date(form.month).getMonth() !== 0"> s/d bulan {{ (new Date(new Date(form.month).getFullYear()-1, (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span>
                                </div>
                                <div class="py-1" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool || item.laba_bool || item.laba_tahun_bool"
                                    :disabled="item.laba_bool || item.laba_tahun_bool"
                                    dense
                                    outlined
                                    hide-details
                                    @input="akumulasiPasiva()"
                                    
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                                <div class="py-1" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool || item.laba_bool || item.laba_tahun_bool"
                                    :disabled="item.laba_bool || item.laba_tahun_bool"
                                    dense
                                    outlined
                                    hide-details
                                    @input="akumulasiPasivaPublic()"
                                    
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo_public"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                              </div>
                              <div v-if="item.child.length > 0">
                                <div v-for="(c1, i1) in item.child" :key="i1">
                                  <div class="d-flex pl-3 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                    <div style="width: 144px; min-width: 144px;" class="py-1" :class="c1.laba_bool ? 'pink--text text--darken-1' : c1.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                      {{ c1.number }}
                                    </div>
                                    <div class="py-1" style="width: 100%;" :class="c1.laba_bool ? 'pink--text text--darken-1' : c1.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                      {{ c1.name }} <span v-if="c1.laba_bool">(Saldo akhir <span>{{ (new Date(new Date(form.month).getFullYear(), (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span> <span v-if="c1.laba_tahun_bool">(saldo akhir Januari<span v-if="new Date(form.month).getMonth() !== 0"> s/d bulan {{ (new Date(new Date(form.month).getFullYear()-1, (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span> 
                                    </div>
                                    <div class="py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool || c1.laba_bool || c1.laba_tahun_bool"
                                        :disabled="c1.laba_bool || c1.laba_tahun_bool"
                                        dense
                                        outlined
                                        hide-details
                                        @input="akumulasiPasiva()"
                                        
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                    <div class="py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool || c1.laba_bool || c1.laba_tahun_bool"
                                        :disabled="c1.laba_bool || c1.laba_tahun_bool"
                                        dense
                                        outlined
                                        hide-details
                                        @input="akumulasiPasivaPublic()"
                                        
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo_public"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                  </div>
                                  <div v-if="c1.child.length > 0">
                                    <div v-for="(c2, i2) in c1.child" :key="i2">
                                      <div class="d-flex pl-6 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                        <div style="width: 132px; min-width: 132px;" class="py-1" :class="c2.laba_bool ? 'pink--text text--darken-1' : c2.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                          {{ c2.number }}
                                        </div>
                                        <div class="py-1" style="width: 100%;" :class="c2.laba_bool ? 'pink--text text--darken-1' : c2.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                          {{ c2.name }} <span v-if="c2.laba_bool">(Saldo akhir<span>{{ (new Date(new Date(form.month).getFullYear(), (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span> <span v-if="c2.laba_tahun_bool">(saldo akhir Januari<span v-if="new Date(form.month).getMonth() !== 0"> s/d bulan {{ (new Date(new Date(form.month).getFullYear()-1, (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span>
                                        </div>
                                        <div class="py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool || c2.laba_bool || c2.laba_tahun_bool"
                                            :disabled="c2.laba_bool || c2.laba_tahun_bool"
                                            dense
                                            outlined
                                            hide-details
                                            @input="akumulasiPasiva()"
                                            
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                        <div class="py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool || c2.laba_bool || c2.laba_tahun_bool"
                                            :disabled="c2.laba_bool || c2.laba_tahun_bool"
                                            dense
                                            outlined
                                            hide-details
                                            @input="akumulasiPasivaPublic()"
                                            
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo_public"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                      </div>
                                      <div v-if="c2.child.length > 0">
                                        <div v-for="(c3, i3) in c2.child" :key="i3">
                                          <div class="d-flex pl-9 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                            <div style="width: 120px; min-width: 120px;" class="py-1" :class="c3.laba_bool ? 'pink--text text--darken-1' : c3.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                              {{ c3.number }}
                                            </div>
                                            <div class="py-1" style="width: 100%;" :class="c3.laba_bool ? 'pink--text text--darken-1' : c3.laba_tahun_bool === true ? 'orange--text text--darken-4' :''">
                                              {{ c3.name }} <span v-if="c3.laba_bool">(Saldo akhir<span>{{ (new Date(new Date(form.month).getFullYear(), (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span> <span v-if="c3.laba_tahun_bool">(saldo akhir Januari<span v-if="new Date(form.month).getMonth() !== 0"> s/d bulan {{ (new Date(new Date(form.month).getFullYear()-1, (new Date(form.month).getMonth()-1))) | month_full }}</span>)</span>
                                            </div>
                                            <div class="py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool || c3.laba_bool || c3.laba_tahun_bool"
                                                :disabled="c3.laba_bool || c3.laba_tahun_bool"
                                                dense
                                                outlined
                                                hide-details
                                                @input="akumulasiPasiva()"
                                                
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                            <div class="py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool || c3.laba_bool || c3.laba_tahun_bool"
                                                :disabled="c3.laba_bool || c3.laba_tahun_bool"
                                                dense
                                                outlined
                                                hide-details
                                                @input="akumulasiPasivaPublic()"
                                                
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo_public"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
  
  
                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600" style="border-bottom: 1px solid #eee;">
                              Pendapatan
                            </div>
                            
                            <div v-for="(item, index) in form.pendapatan_array" :key="index">
                              <div class="d-flex align-center fs-12" style="border-bottom: 1px solid #eee;">
                                <div style="width: 156px; min-width: 156px;" class="py-1">
                                  {{ item.number }}
                                </div>
                                <div class="py-1" style="width: 100%">
                                  {{ item.name }}
                                </div>
                                <div class="py-1" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool"
                                    dense
                                    outlined
                                    hide-details
                                    @input="akumulasiPendapatan()"
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                                <div class="py-1" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool"
                                    dense
                                    outlined
                                    hide-details
                                    @input="akumulasiPendapatanPublic()"
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo_public"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                              </div>
                              <div v-if="item.child.length > 0">
                                <div v-for="(c1, i1) in item.child" :key="i1">
                                  <div class="d-flex pl-3 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                    <div style="width: 144px; min-width: 144px;" class="py-1">
                                      {{ c1.number }}
                                    </div>
                                    <div class="py-1" style="width: 100%">
                                      {{ c1.name }}
                                    </div>
                                    <div class="py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool"
                                        dense
                                        outlined
                                        hide-details
                                        @input="akumulasiPendapatan()"
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                    <div class="py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool"
                                        dense
                                        outlined
                                        hide-details
                                        @input="akumulasiPendapatanPublic()"
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo_public"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                  </div>
                                  <div v-if="c1.child.length > 0">
                                    <div v-for="(c2, i2) in c1.child" :key="i2">
                                      <div class="d-flex pl-6 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                        <div style="width: 132px; min-width: 132px;" class="py-1">
                                          {{ c2.number }}
                                        </div>
                                        <div class="py-1" style="width: 100%">
                                          {{ c2.name }}
                                        </div>
                                        <div class="py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool"
                                            dense
                                            outlined
                                            hide-details
                                            @input="akumulasiPendapatan()"
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                        <div class="py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool"
                                            dense
                                            outlined
                                            hide-details
                                            @input="akumulasiPendapatanPublic()"
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo_public"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                      </div>
                                      <div v-if="c2.child.length > 0">
                                        <div v-for="(c3, i3) in c2.child" :key="i3">
                                          <div class="d-flex pl-9 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                            <div style="width: 120px; min-width: 120px;" class="py-1">
                                              {{ c3.number }}
                                            </div>
                                            <div class="py-1" style="width: 100%">
                                              {{ c3.name }}
                                            </div>
                                            <div class="py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool"
                                                dense
                                                outlined
                                                hide-details
                                                @input="akumulasiPendapatan()"
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                            <div class="py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool"
                                                dense
                                                outlined
                                                hide-details
                                                @input="akumulasiPendapatanPublic()"
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo_public"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
  
  
                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600" style="border-bottom: 1px solid #eee;">
                              Biaya
                            </div>
                            
                            <div v-for="(item, index) in form.biaya_array" :key="index">
                              <div class="d-flex align-center fs-12" style="border-bottom: 1px solid #eee;">
                                <div style="width: 156px; min-width: 156px;" class="py-1">
                                  {{ item.number }}
                                </div>
                                <div class="py-1" style="width: 100%;">
                                  {{ item.name }}
                                </div>
                                <div class="py-2" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool"
                                    dense
                                    outlined
                                    hide-details
                                    @input="akumulasiBiaya()"
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                                <div class="py-1" v-if="item.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                  <v-currency-field
                                    rounded
                                    :readonly="saldo_awal_bool"
                                    dense
                                    outlined
                                    hide-details
                                    @input="akumulasiBiayaPublic()"
              
                                    :color="set_color"
                                    placeholder="Saldo"
                                    :error-messages="errors"
  
                                    
                                    class="min-height-input fs-14"
                                    v-model="item.saldo_public"
                                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                                  </v-currency-field>
                                </div>
                              </div>
                              <div v-if="item.child.length > 0">
                                <div v-for="(c1, i1) in item.child" :key="i1">
                                  <div class="d-flex pl-3 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                    <div style="width: 144px; min-width: 144px;" class="py-1">
                                      {{ c1.number }}
                                    </div>
                                    <div class="py-1" style="width: 100%;">
                                      {{ c1.name }}
                                    </div>
                                    <div class="py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool"
                                        dense
                                        outlined
                                        @input="akumulasiBiaya()"
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                    <div class="py-1" v-if="c1.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                      <v-currency-field
                                        rounded
                                        :readonly="saldo_awal_bool"
                                        dense
                                        outlined
                                        @input="akumulasiBiayaPublic()"
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Saldo"
                                        :error-messages="errors"
  
                                        
                                        class="min-height-input fs-14"
                                        v-model="c1.saldo_public"
                                        style="border-radius: 10px; width: 200px; max-width: 200px;">
                                      </v-currency-field>
                                    </div>
                                  </div>
                                  <div v-if="c1.child.length > 0">
                                    <div v-for="(c2, i2) in c1.child" :key="i2">
                                      <div class="d-flex pl-6 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                        <div style="width: 132px; min-width: 132px;" class="py-1">
                                          {{ c2.number }}
                                        </div>
                                        <div class="py-1" style="width: 100%;">
                                          {{ c2.name }}
                                        </div>
                                        <div class="py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool"
                                            dense
                                            outlined
                                            hide-details
                                            @input="akumulasiBiaya()"
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                        <div class="py-1" v-if="c2.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                          <v-currency-field
                                            rounded
                                            :readonly="saldo_awal_bool"
                                            dense
                                            outlined
                                            hide-details
                                            @input="akumulasiBiayaPublic()"
                      
                                            :color="set_color"
                                            placeholder="Saldo"
                                            :error-messages="errors"
            
                                            
                                            class="min-height-input fs-14"
                                            v-model="c2.saldo_public"
                                            style="border-radius: 10px; width: 200px; max-width: 200px;">
                                          </v-currency-field>
                                        </div>
                                      </div>
                                      <div v-if="c2.child.length > 0">
                                        <div v-for="(c3, i3) in c2.child" :key="i3">
                                          <div class="d-flex pl-9 align-center fs-12" style="border-bottom: 1px solid #eee;">
                                            <div style="width: 120px; min-width: 120px;" class="py-1">
                                              {{ c3.number }}
                                            </div>
                                            <div class="py-1" style="width: 100%;">
                                              {{ c3.name }}
                                            </div>
                                            <div class="py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool"
                                                dense
                                                outlined
                                                hide-details
                                                @input="akumulasiBiaya()"
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                            <div class="py-1" v-if="c3.child.length < 1" style="width: 300px; max-width: 300px; justify-content: end; display: flex; min-width: 300px;">
                                              <v-currency-field
                                                rounded
                                                :readonly="saldo_awal_bool"
                                                dense
                                                outlined
                                                hide-details
                                                @input="akumulasiBiayaPublic()"
                          
                                                :color="set_color"
                                                placeholder="Saldo"
              
                                                
                                                class="min-height-input fs-14"
                                                v-model="c3.saldo_public"
                                                style="border-radius: 10px; width: 200px; max-width: 200px;">
                                              </v-currency-field>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                        </v-form>
                      </ValidationObserver>

                    </v-card-text>
                    
                    <v-divider 
                    class="mt-2"
                    style="border-top: 2px dashed #e0e0e0;"/>
                    
                    <v-card-actions
                    class="pa-4 py-2">
                    <div v-if="message.error.length > 0"
                      class="text-left">
                      <div
                        class="error--text d-flex align-start">
                        <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                      <v-spacer/>

                      <v-btn
                        @click="saldo_awal_bool ? '' : save()"
                        :loading="process.form"
                        :disabled="process.form || saldo_awal_bool"
                        width="120"
                        color="#4B4B4B"
                        small
                        min-height="30"
                        elevation="0"
                        class="fs-12 white--text text-capitalize ml-3"
                        :style="process.form || saldo_awal_bool ? '' : 'background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));'"
                        style="border-radius: 10px; font-weight: 600; ">
                        <v-icon
                          size="18">
                          mdi-checkbox-marked-circle-outline
                        </v-icon>

                        <span
                          class="ml-2">
                          Simpan
                        </span>
                      </v-btn>

                      <v-btn
                        @click="saldo_awal_bool = true; fetchData();"
                        :disabled="process.form"
                        width="120"
                        v-if="!saldo_awal_bool && saldo_awal_bool_awal"
                        
                        color="red"
                        elevation="0"
                        class="body-2 white--text text-capitalize d-flex align-center ml-4"
                        style="border-radius: 10px; font-weight: 600;">
                        <v-icon 
                          size="20">
                          mdi-progress-close
                        </v-icon>

                        <span
                          class="ml-2">
                          Batal
                        </span>
                      </v-btn>
                    </v-card-actions>
                    <!-- <v-card-text
                      v-if="list.length === 0"
                      class="pb-0 my-4" style="height: calc( 100vh - 250px ); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="90"
                          :height="90"
                          :src="require('@/assets/image/empty.png')">
                        </v-img>
                        <div class="mt-3 fs-16">
                          Belum Ada Neraca
                        </div>
                      </div>
                    </v-card-text> -->
                
                  </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
          komfirmasi: false,
        },
        
        search: '',
        picker: {
          range: false,

          start_date: false,
          end_date: false,
          month: false
        },

        total_aktiva: 0,
        total_pasiva: 0,
        total_pendapatan: 0,
        total_biaya: 0,
        total_aktiva_public: 0,
        total_pasiva_public: 0,
        total_pendapatan_public: 0,
        total_biaya_public: 0,

        menu2: false,
        filter: {
          date: '',
          year: new Date().getFullYear(),

          month: 1,
          month_text: 'Januari',
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          activa: '',
          pasiva: ''
        },
        saldo_awal_bool: false,
        saldo_awal_bool_awal: false,

        role: [],

        options: {},
        headers: [],
        list: [],
        list_aktiva: [],
        list_pasiva: [],
        list_pendapatan: [],
        list_biaya: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          month: moment().format('YYYY-MM'),
          position: '',
          pasiva_array: [],
          aktiva_array: [],
          biaya_array: [],
          pendapatan_array: [],
        },
        data_month: '',

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'filter.year': function () {
        this.fetch()
      },

      'filter.month': function () {
        let t = this

        let m = this.months.filter(function(v) {
          return t.filter.month == v.value
        })

        if (m.length > 0) {
          this.filter.month_text = m[0].text
        }
        this.fetch()
      },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      years () {
        let max = new Date().getFullYear()+4, min = max - 8, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      // this.fetch()
      this.fetchData()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = false

        this.limit = pagination.row

        let params = {
          // limit: pagination.row,
          // page: pagination.page,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          // search: this.search
          month: this.filter.month,
          year: this.filter.year
        }

        this.selected.row = []

        await get(`balance/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.list_pasiva = []
          // this.total_aktiva = this.filter.month === 1 ? 87560000 : 0
          // this.total_pasiva = this.filter.month === 1 ? 87560000 : 0
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'Aksi',
              //   width: '120px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'center',
              //   format: 'action'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '100%',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]

            for (let i = 0; i < res.results.data.length; i++) {
              if(res.results.data[i].type === 'aktiva') {
                this.list.push(res.results.data[i])
              } else if(res.results.data[i].type === 'pasiva') {
                this.list_pasiva.push(res.results.data[i])
              }
            }

            // this.list.map((item, index) => {
            //   this.total_aktiva += (item.balance*1)
            // })

            // this.list_pasiva.map((item, index) => {
            //   this.total_pasiva += (item.balance*1)
            // })

            // this.list = res.results.data
            // this.pagination = res.results.pagination


            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1

            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper-saldo-awal') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      akumulasiAktiva () {
        this.total_aktiva = 0
        this.form.aktiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_aktiva += (item4.saldo*1)
                    })
                  } else {
                    this.total_aktiva += (item3.saldo*1)
                  }
                })
              } else {
                this.total_aktiva += (item2.saldo*1)
              }
            })
          } else {
            this.total_aktiva += (item.saldo*1)
          }
        })
      },

      akumulasiAktivaPublic () {
        this.total_aktiva_public = 0
        this.form.aktiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_aktiva_public += (item4.saldo_public*1)
                    })
                  } else {
                    this.total_aktiva_public += (item3.saldo_public*1)
                  }
                })
              } else {
                this.total_aktiva_public += (item2.saldo_public*1)
              }
            })
          } else {
            this.total_aktiva_public += (item.saldo_public*1)
          }
        })
      },

      akumulasiPasiva () {
        this.total_pasiva = 0
        this.form.pasiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_pasiva += (item4.saldo*1)
                    })
                  } else {
                    this.total_pasiva += (item3.saldo*1)
                  }
                })
              } else {
                this.total_pasiva += (item2.saldo*1)
              }
            })
          } else {
            this.total_pasiva += (item.saldo*1)
          }
        })
      },

      akumulasiPasivaPublic () {
        this.total_pasiva_public = 0
        this.form.pasiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_pasiva_public += (item4.saldo_public*1)
                    })
                  } else {
                    this.total_pasiva_public += (item3.saldo_public*1)
                  }
                })
              } else {
                this.total_pasiva_public += (item2.saldo_public*1)
              }
            })
          } else {
            this.total_pasiva_public += (item.saldo_public*1)
          }
        })
      },

      akumulasiPendapatan () {
        this.total_pendapatan = 0
        this.form.pendapatan_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_pendapatan += (item4.saldo*1)
                    })
                  } else {
                    this.total_pendapatan += (item3.saldo*1)
                  }
                })
              } else {
                this.total_pendapatan += (item2.saldo*1)
              }
            })
          } else {
            this.total_pendapatan += (item.saldo*1)
          }
        })
        this.form.pasiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      item4.saldo = item4.laba_bool ? this.total_pendapatan  - this.total_biaya : item4.saldo
                    })
                  } else {
                    item3.saldo = item3.laba_bool ? this.total_pendapatan  - this.total_biaya : item3.saldo
                  }
                })
              } else {
                item2.saldo = item2.laba_bool ? this.total_pendapatan  - this.total_biaya : item2.saldo
              }
            })
          } else {
            item.saldo = item.laba_bool ? this.total_pendapatan  - this.total_biaya : item.saldo
          }
        })
        this.akumulasiPasiva()
      },

      akumulasiPendapatanPublic () {
        this.total_pendapatan_public = 0
        this.form.pendapatan_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_pendapatan_public += (item4.saldo_public*1)
                    })
                  } else {
                    this.total_pendapatan_public += (item3.saldo_public*1)
                  }
                })
              } else {
                this.total_pendapatan_public += (item2.saldo_public*1)
              }
            })
          } else {
            this.total_pendapatan_public += (item.saldo_public*1)
          }
        })
        this.form.pasiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      item4.saldo_public = item4.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item4.saldo_public
                    })
                  } else {
                    item3.saldo_public = item3.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item3.saldo_public
                  }
                })
              } else {
                item2.saldo_public = item2.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item2.saldo_public
              }
            })
          } else {
            item.saldo_public = item.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item.saldo_public
          }
        })
        this.akumulasiPasivaPublic()
      },

      akumulasiBiaya () {
        this.total_biaya = 0
        this.form.biaya_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_biaya += (item4.saldo*1)
                    })
                  } else {
                    this.total_biaya += (item3.saldo*1)
                  }
                })
              } else {
                this.total_biaya += (item2.saldo*1)
              }
            })
          } else {
            this.total_biaya += (item.saldo*1)
          }
        })

        this.form.pasiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      item4.saldo = item4.laba_bool ? this.total_pendapatan  - this.total_biaya : item4.saldo
                    })
                  } else {
                    item3.saldo = item3.laba_bool ? this.total_pendapatan  - this.total_biaya : item3.saldo
                  }
                })
              } else {
                item2.saldo = item2.laba_bool ? this.total_pendapatan  - this.total_biaya : item2.saldo
              }
            })
          } else {
            item.saldo = item.laba_bool ? this.total_pendapatan  - this.total_biaya : item.saldo
          }
        })
        this.akumulasiPasiva()
      },

      akumulasiBiayaPublic () {
        this.total_biaya_public = 0
        this.form.biaya_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      this.total_biaya_public += (item4.saldo_public*1)
                    })
                  } else {
                    this.total_biaya_public += (item3.saldo_public*1)
                  }
                })
              } else {
                this.total_biaya_public += (item2.saldo_public*1)
              }
            })
          } else {
            this.total_biaya_public += (item.saldo_public*1)
          }
        })

        this.form.pasiva_array.map((item, index) => {
          if (item.child.length > 0) {
            item.child.map((item2, index2) => {
              if (item2.child.length > 0) {
                item2.child.map((item3, index3) => {
                  if (item3.child.length > 0) {
                    item3.child.map((item4, index4) => {
                      item4.saldo_public = item4.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item4.saldo_public
                    })
                  } else {
                    item3.saldo_public = item3.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item3.saldo_public
                  }
                })
              } else {
                item2.saldo_public = item2.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item2.saldo_public
              }
            })
          } else {
            item.saldo_public = item.laba_bool ? this.total_pendapatan_public  - this.total_biaya_public : item.saldo_public
          }
        })
        this.akumulasiPasivaPublic()
      },

      async fetchData (data) {
        this.process.load = true
        let params = {
          limit: 100000
          // year: moment().format('YYYY')
        }
        
        await get('neraca/initial/data')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.list_aktiva = []
            this.list_pasiva = []
            this.list_biaya = []
            this.list_pendapatan = []

            res.results.data.aktiva_array.map((item, index) => {
              this.list_aktiva.push(item)
            })

            res.results.data.pasiva_array.map((item, index) => {
              this.list_pasiva.push(item)
            })

            res.results.data.biaya_array.map((item, index) => {
              this.list_biaya.push(item)
            })

            res.results.data.pendapatan_array.map((item, index) => {
              this.list_pendapatan.push(item)
            })

            // this.list_aktiva = res.results.data.aktiva_array
            // this.list_pasiva  = res.results.data.pasiva_array
            // this.list_biaya   = res.results.data.biaya_array
            // this.list_pendapatan = res.results.data.pendapatan_array
            this.data_month = res.results.data.month
            this.saldo_awal_bool = res.results.data.saldo_awal_bool
            this.saldo_awal_bool_awal = res.results.data.saldo_awal_bool
            this.reset()

            this.process.load = false
            
            // res.results.data.map((item) => {
            //   this.item.push({ 
            //     debit: 0,
            //     kredit: 0,
            //     id: item.id,
            //     name: item.name,
            //     number: item.number
            //   })

            //   this.item_coa_jurnal.push({ 
            //     total_debit: 0,
            //     total_kredit: 0,
            //     id: item.id,
            //     name: item.name,
            //     number: item.number
            //   })
            // })

            // this.menu = res.results.data.map(item => {
            //   return {
            //     menu: false
            //   }
            // })

            // this.modalTime = res.results.data.map((item, index) => {
            //   return {
            //     menu: false,
            //     reft: `time${index}`
            //   }
            // })
          }
        })
      },

      // closeForm() {
      //   this.form.pasiva_array = []
      //   this.form.aktiva_array = []
      //   this.list_aktiva.map((item, index) => {
      //     this.form.aktiva_array.push(item)
      //   })

      //   this.list_pasiva.map((item, index) => {
      //     this.form.pasiva_array.push(item)
      //   })
      // },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        // this.form.month = moment().format('YYYY-MM')
        this.total_aktiva = 0
        this.total_pasiva = 0
        this.total_pendapatan = 0
        this.total_biaya = 0
        this.total_aktiva_public = 0
        this.total_pasiva_public = 0
        this.total_pendapatan_public = 0
        this.total_biaya_public = 0
        this.form.position = ''
        this.message.error = ''
        this.form.pasiva_array = []
        this.form.aktiva_array = []
        this.form.biaya_array = []
        this.form.pendapatan_array = []
        this.form.month = this.data_month
        this.list_aktiva.map((item, index) => {
          this.form.aktiva_array.push(item)
        })

        this.list_pasiva.map((item, index) => {
          this.form.pasiva_array.push(item)
        })

        this.list_biaya.map((item, index) => {
          this.form.biaya_array.push(item)
        })

        this.list_pendapatan.map((item, index) => {
          this.form.pendapatan_array.push(item)
        })

        setTimeout(() => {
          this.akumulasiAktiva()
          this.akumulasiPasiva()
          this.akumulasiPendapatan()
          this.akumulasiBiaya()

          this.akumulasiAktivaPublic()
          this.akumulasiPasivaPublic()
          this.akumulasiPendapatanPublic()
          this.akumulasiBiayaPublic()

        }, 1000)

        
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = 'neraca/initial/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              month: this.form.month,
              position: this.form.position,
              pasiva_array: this.form.pasiva_array,
              aktiva_array: this.form.aktiva_array,
              biaya_array: this.form.biaya_array,
              pendapatan_array: this.form.pendapatan_array
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // if (this.form.id === '') {
              //   this.fetch()
              // } else {
              //   this.fetch(this.paginationList)
              // }
              this.fetchData()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/satuan/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper-saldo-awal { 
  overflow-y: auto; 
  height: calc(100vh - 260px); 
} 
.wrapper-saldo-awal th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}

</style>